var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.81656 10.457L0.402344 9.04282L4.19524 5.24992L0.402343 1.45703L1.81656 0.042818L7.02366 5.24992L1.81656 10.457Z"}));
}

ChevronRight.defaultProps = {"width":"8","height":"11","viewBox":"0 0 8 11","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
